if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

$(window).on('load', function() {
   jQuery('.iia-address:contains("New Jersey 07055")').remove();
  var interval = setInterval(function() {
        jQuery('.iia-address:contains("New Jersey 07055")').remove();
}, 1); 

  setTimeout(function(){
     jQuery('div#inventory-info-app').css("opacity", "1");
  }, 50);
});

jQuery(document).ready(function() {
    jQuery('variant-selects .product-form__input:first-child select option').each(function() {
        var unavialableTxt = jQuery(this).text();
        if (unavialableTxt.includes('Unavailable')) {
            jQuery(this).remove(); // Remove the option
        }
    });
  var ifmoreOne = jQuery('variant-selects .product-form__input').length;
  if (ifmoreOne === 2 ){
    jQuery('variant-selects .product-form__input').eq(1).find('select option').each(function() {
        var unavialableTxtt = jQuery(this).text();
        if (unavialableTxtt.includes('Unavailable')) {
            jQuery(this).css("display", "none");
            jQuery(this).addClass("not-avail-opss");
        }
    });
    jQuery('variant-selects .product-form__input:first-child select').change(function () {
            var secondSelect = jQuery(this).closest('variant-selects').find('.product-form__input').eq(1).find('select');
            setTimeout(function () {
              jQuery('.product-form__buttons button span').text("Select Size");
            }, 0); 
            setTimeout(function () {
                jQuery('.product-form__buttons button span').hide();
                  if (jQuery('.product-form__buttons button sel').length === 0) {
                      jQuery('.product-form__buttons button').append("<sel>Select Size</sel>");
                      jQuery('.product-form__buttons button').attr('disabled', 'disabled');
                  }
                jQuery('.product-form__buttons button').attr('disabled', 'disabled');
                jQuery('.product-form__buttons button sel').show();
                jQuery('.product__inventory').hide();
                secondSelect.append('<option class="select-size" selected="selected" disabled>Select Size</option>');
                secondSelect.on("change", function() {
                    jQuery('.product-form__buttons buttons').removeAttr('disabled');
                    jQuery('.select-size').remove();
                    jQuery('.product-form__buttons button sel').hide();
                    jQuery('.product__inventory').show();
                    setTimeout(function(){
                      jQuery('.product-form__buttons button span').show();
                    }, 500);
                });
                var unavailableOptions = [];
                secondSelect.find('option').each(function () {
                    var optionText = jQuery(this).text();
                    jQuery(this).removeAttr('selected');
                    if (optionText.includes('Unavailable')) {
                        jQuery(this).css("display", "none"); 
                        jQuery(this).addClass("not-avail-opss");
                        jQuery(this).attr('disabled', 'disabled');
                        // jQuery(this).remove(); // Remove the option from the DOM
                    }else{
                        jQuery(this).css("display", "block");
                        jQuery(this).removeClass("not-avail-opss");
                        jQuery(this).attr('selected', 'selected');
                        jQuery(this).removeAttr('disabled');
                    }
                });
            }, 0); 
      });
  }
  jQuery('.mobo-add-to-cart').click(function(){
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
});
});


//   $(document).ready(function () {
//     var $originalInput = $('.product-variant-id');
//     var $targetInput = $('.main-mobo-sticky .product-variant-id');
//     if ($originalInput.length && $targetInput.length) {
//         $targetInput.val($originalInput.val());
//         var lastVal = $originalInput.val();
//         setInterval(function () {
//             var currentVal = $originalInput.val();
//             if (currentVal !== lastVal) {
//                 lastVal = currentVal;
//                 $targetInput.val(currentVal);
//                 console.log("Value updated to:", currentVal); // Optional for debugging
//             }
//         }, 100); 
//     }
// });